var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmationCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4633 31.0919C53.38 30.0071 51.6189 30.0071 50.5355 31.0919L38.6105 43.0155L33.63 38.0363C32.5467 36.9516 30.7855 36.9516 29.7022 38.0363C28.6175 39.121 28.6175 40.8794 29.7022 41.9641L36.6467 48.9085C37.1883 49.4516 37.8994 49.7224 38.6105 49.7224C39.3217 49.7224 40.0328 49.4516 40.5744 48.9085L54.4633 35.0196C55.548 33.9349 55.548 32.1766 54.4633 31.0919Z",
    fill: "#7ED957",
    stroke: "#7ED957",
    strokeWidth: 0.925
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5549 37.2221C69.0216 37.2221 67.7771 38.4665 67.7771 39.9998C67.7771 55.3165 55.316 67.7776 39.9993 67.7776C24.6827 67.7776 12.2216 55.3165 12.2216 39.9998C12.2216 24.6832 24.6827 12.2221 39.9993 12.2221C47.4563 12.2221 54.4563 15.1359 59.7118 20.4276C60.791 21.5179 62.5507 21.5234 63.6396 20.4415C64.7285 19.3609 64.7341 17.6026 63.6535 16.5137C57.348 10.1637 48.9466 6.6665 39.9993 6.6665C21.6188 6.6665 6.66602 21.6193 6.66602 39.9998C6.66602 58.3804 21.6188 73.3332 39.9993 73.3332C58.3799 73.3332 73.3327 58.3804 73.3327 39.9998C73.3327 38.4665 72.0882 37.2221 70.5549 37.2221Z",
    fill: "#7ED957",
    stroke: "#7ED957",
    strokeWidth: 0.925
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationCheck);
export default __webpack_public_path__ + "static/media/confirmation-check.c042c2629506beb3e24595a00ad54ccd.svg";
export { ForwardRef as ReactComponent };